import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCheck } from "@fortawesome/pro-light-svg-icons";
import {
  faUtensils,
  faClock,
  faBuilding,
} from "@fortawesome/pro-solid-svg-icons";

/**
 * Audience selection card for entry page (dark theme)
 * @param {string} variant - Card variant: restaurant, consumer, company
 * @param {string} title - Card title
 * @param {array} benefits - Array of short benefit strings
 * @param {string} cta - Call to action text
 * @param {string} image - Image URL for the card
 * @param {function} onClick - Click handler
 */
function AudienceCard({ variant, title, benefits = [], cta, image, onClick }) {
  const icons = {
    restaurant: faUtensils,
    consumer: faClock,
    company: faBuilding,
  };

  return (
    <div
      className={`audience-card audience-card--${variant}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => e.key === "Enter" && onClick()}
      data-analytics={`cta-audience-${variant}`}
      data-analytics-location="entry-page"
    >
      {/* Image at top */}
      {image && (
        <div className="audience-card__image">
          <img src={image} alt="" />
        </div>
      )}

      <div className="audience-card__content">
        {/* Header with icon and title */}
        <div className="audience-card__header">
          <div className="audience-card__icon">
            <FontAwesomeIcon icon={icons[variant]} />
          </div>
          <h3 className="audience-card__title">{title}</h3>
        </div>

        {/* Benefits list */}
        {benefits.length > 0 && (
          <ul className="audience-card__benefits">
            {benefits.map((benefit, index) => (
              <li key={index} className="audience-card__benefit-item">
                <FontAwesomeIcon icon={faCheck} />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        )}

        {/* CTA */}
        <div className="audience-card__cta">
          <span>{cta}</span>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </div>
    </div>
  );
}

export default AudienceCard;
